import Aggregator from "./Aggregator";

export default Aggregator;
